/**
 *
 * @module subscriptionSource
 *
 */

import Check from 'check-types';
import Services from './../services/entry';
import SubscriptionProvider from './subscriptionProvider';

const SubscriptionSourceSubType = Services.Subscription.SubscriptionSourceSubType;
const SubscriptionSourceType = Services.Subscription.SubscriptionSourceType;

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    nonEmptyObject,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class SubscriptionSource
 * @desc Represents a source a subscription can be from.
 *
 */
export default class SubscriptionSource {

    /**
     *
     * @param {Object} options
     * @param {String} options.provider
     * @param {String} options.ref
     * @param {String} [options.subType=undefined]
     * @param {String} options.type
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'SubscriptionSource(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get provider() {
                return `${this.ctor} options.provider should be a String with length`;
            },
            get ref() {
                return `${this.ctor} options.ref should be a String with length`;
            },
            get type() {
                return `${this.ctor} options.type should be a String with length`;
            },
            get subType() {
                return `${this.ctor} options.subType should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { provider, ref, subType, type } = options;

        nonEmptyString(provider, errorMessage.provider, InvalidArgumentException);
        nonEmptyString(ref, errorMessage.ref, InvalidArgumentException);
        nonEmptyString(type, errorMessage.type, InvalidArgumentException);

        if (Check.assigned(subType)) {
            nonEmptyString(subType, errorMessage.subType, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets the provider of the subscription.
         *
         */
        this.provider = SubscriptionProvider[provider] || SubscriptionProvider.OTHER;

        /**
         *
         * @access private
         * @type {String}
         * @desc Gets the reference name of the source.
         *
         */
        this.ref = ref;

        /**
         *
         * @access private
         * @type {SDK.Services.Subscription.SubscriptionSourceSubType|undefined}
         * @desc Gets the subtype of the source.
         *
         */
        this.subType = SubscriptionSourceSubType[subType];

        /**
         *
         * @access private
         * @type {SDK.Services.Subscription.SubscriptionSourceType}
         * @desc Gets the type of the source.
         *
         */
        this.type = SubscriptionSourceType[type];

    }

}



// WEBPACK FOOTER //
// ./src/subscription/subscriptionSource.js